@if (getIcon(); as ic) {
  <ix-layout-grid class="px-0">
    <ix-row>
      <ix-col class="d-inline-flex p-0">
        <img class="d-inline-block" [src]="ic"
             [alt]="attributeValue"
             width="25"
             height="25">
        <ix-typography class="d-inline-flex ps-3">{{ attributeValue }}
        </ix-typography>
      </ix-col>
    </ix-row>
  </ix-layout-grid>
} @else {
  <ix-typography>{{ languageCode.toUpperCase() }} — {{ attributeValue }}</ix-typography>
}
